import React from "react";
import { NumberCard } from "../../../UI/components/NumberCard";
import { gql } from "apollo-boost";
import { useSubscription } from "@apollo/react-hooks";
import { toLiskEpoch } from "../../utils/lisk/utils/lisk/time";

const now = new Date();
const yesterday = now.setDate(now.getDate() - 1);
const yesterdayLiskEpoch = toLiskEpoch(yesterday);
const LAST_DAY_TX_COUNT_SUBSCRIPTION = gql`
  subscription($when: Int!) {
    transactions_public_aggregate(where: { timestamp: { _gt: $when } }) {
      aggregate {
        count(columns: id)
      }
    }
  }
`;

export const TxLastDayCard: React.FC = () => {
  const { data, loading, error } = useSubscription(
    LAST_DAY_TX_COUNT_SUBSCRIPTION,
    {
      variables: { when: yesterdayLiskEpoch },
    }
  );

  const totalTxCount =
    data &&
    data.transactions_public_aggregate &&
    data.transactions_public_aggregate &&
    data.transactions_public_aggregate.aggregate.count
      ? data.transactions_public_aggregate.aggregate.count
      : 0;

  return (
    <>
      <NumberCard
        data={totalTxCount.toLocaleString()}
        icon={"fas fa-angle-double-up"}
        title={"Transactions in the last 24h"}
        loading={loading}
        error={!!error}
      />
    </>
  );
};
